import { memo } from 'react';

interface PiqueLogoProps {
  className?: string;
}

export const PiqueLogo = memo(({ className }: PiqueLogoProps) => {
  return (
    <svg
      width="32"
      height="29"
      viewBox="0 0 348 348"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      data-pique-logo=""
    >
      <path
        d="M188.607 128.614C188.607 113.551 176.458 101.341 161.473 101.341C146.487 101.341 134.338 113.551 134.338 128.614V225.583C134.338 240.646 146.487 252.856 161.473 252.856C176.458 252.856 188.607 240.646 188.607 225.583V128.614Z"
        fill="#A756F4"
      />
      <path
        d="M120.269 168.007C120.269 152.945 108.12 140.734 93.1343 140.734C78.1485 140.734 66 152.945 66 168.007V186.189C66 201.251 78.1485 213.462 93.1343 213.462C108.12 213.462 120.269 201.251 120.269 186.189V168.007Z"
        fill="#BD4FF1"
      />
      <path
        d="M259.091 269.958C259.091 271.338 258.649 272.703 257.788 273.977L234.925 307.828C234.117 309.024 231.393 309.062 230.496 307.891L204.698 274.165C203.63 272.77 203.078 271.248 203.078 269.707V100.516C203.078 94.7531 210.642 90.0773 219.991 90.061L242.081 90.0225C251.468 90.0061 259.091 94.6916 259.091 100.477V269.958Z"
        fill="#8D5CF5"
      />
      <path
        d="M258.7 75.809C258.734 78.3041 256.268 80.3448 253.206 80.3564L207.825 80.5271C204.722 80.5388 202.216 78.4646 202.281 75.9368L202.817 54.7609C202.825 50.702 205.287 46.4724 208.833 43.5835C210.575 42.1576 212.642 41.0242 214.916 40.2488C217.19 39.4732 219.627 39.071 222.084 39.0651L239.352 39.0002C241.802 38.9906 244.227 39.3761 246.485 40.1345C248.744 40.8929 250.792 42.0093 252.511 43.4192C256.05 46.3021 258.434 50.4968 258.41 54.56L258.7 75.809Z"
        fill="#8D5CF5"
      />
    </svg>
  );
});

PiqueLogo.displayName = 'PiqueLogo';
